import { render, staticRenderFns } from "./AccessDenied.vue?vue&type=template&id=c4c66e3e&scoped=true&"
import script from "./AccessDenied.vue?vue&type=script&lang=js&"
export * from "./AccessDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c66e3e",
  null
  
)

export default component.exports